// Disclaimer copy aligns with the existing macro dashboard's footer
// language so the brand voice and legal posture are consistent across
// products. Educational-purpose-only framing required on every screen
// that surfaces projections (per project rules — see CLAUDE.md).
export default function Disclaimer() {
  return (
    <footer className="border-t border-stone-800/60 bg-stone-950/40 mt-12">
      <div className="max-w-6xl mx-auto px-6 py-6 text-xs text-stone-500 leading-relaxed">
        <p>
          <span className="font-semibold text-stone-400">Educational purposes only.</span>{' '}
          BMore Wealthy Stack is a habit-tracking tool. Nothing here is financial,
          investment, tax, or legal advice. Bitcoin is volatile and may lose value.
          Projections are based on a historical power-law fit and should not be read
          as predictions. Decisions about your money are yours alone.
        </p>
        <p className="mt-3 text-stone-600">
          BMore Wealthy · companion to the{' '}
          <a
            href="https://bmorewealthy.net"
            target="_blank"
            rel="noopener noreferrer"
            className="underline hover:text-amber-400"
          >
            BTC macro dashboard
          </a>
          .
        </p>
      </div>
    </footer>
  );
}
